module.exports = __webpack_public_path__ + "static/media/Logo.8289ba56.svg";